module.exports = __webpack_public_path__ + "static/img/brann.d2d3150.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brann.jpg
// module id = qPQV
// module chunks = 1